export const change_screen_mode = "change_screen_mode";
export const set_frequency = "set_frequency";
export const set_auth_data = "set_auth_data";
export const set_services = "set_services";